import { API } from "@project/shared"
import { TenantInterface } from "../../interface"

export const tenantDetail = async (id: number): Promise<any> => {
  return API.get<TenantInterface>(`/tenant_info/${id}`)
}
